export const findKnowledgeBaseByIdOrGetDefault = (knowledgeBases, requestedKnowledgeBaseId) => {
  if (knowledgeBases.length === 0) return null;
  const defaultKnowledgeBase = knowledgeBases[0];
  const foundKnowledgeBase = knowledgeBases.find(knowledgeBase => {
    return knowledgeBase.id === requestedKnowledgeBaseId;
  });
  return foundKnowledgeBase || defaultKnowledgeBase;
};